export function isValidUrl(value) {
    const s = String(value || "").trim();
    if (!s) return false;
  
    try {
      // allow http(s) and other URL types if needed; tighten if you want only http(s)
      // eslint-disable-next-line no-new
      new URL(s);
      return true;
    } catch {
      return false;
    }
  }
  
  export function normalizeUrl(value) {
    return String(value || "").trim();
  }
  